exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".main-role-list {\n\n\n}\n\n.main-role-list .inblock {\n    margin-left: 25px;\n}\n\n.desc {\n    font-style: italic;\n    opacity: 0.6;\n}\n\n.role-name {\n    font-weight: bold;\n    font-size: 1.5em;\n}\n\n.x-sub .role-name {\n    font-size: 1.2em;\n}\n\n.role-sub-block {\n    transition: all 0.5s;\n    height: 0;\n    overflow: hidden;\n}\n\n.role-sub-block.vis {\n    height: auto;\n}\n\n.link-open {\n    cursor: pointer;\n}\n.link-open:hover {\n    opacity: 0.6;\n}\n\n.link {\n    cursor: pointer;\n}\n.link:hover {\n    opacity: 0.6;\n}\n\n.inblock.add {\n    background: rgba(120,0,0,0.03);\n    border: solid 1px rgba(60,0,0,0.4);\n    border-radius: 4px;\n    padding: 4px;\n}\n\n.click-edit {\n    cursor: default;\n}\n\n.add {\n    margin-top: 8px;\n}\n\n.last {\n    font-style: italic;\n    font-weight: normal;\n    color: rgba(0,0,60,0.7);\n}\n\n.error {\n    background: rgba(255,0,0,0.3);\n}\n.txt-error {\n    color: red;\n    display: block;\n    font-size: 13px;\n    margin-left: 15px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/views/role/role-editor/role-editor.css
// module id = 1229
// module chunks = 9